import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ApiRequestsService } from '@base/api/api.gateway';
import { ProjectsService } from '@eyrus/shared/services';

@Component({
  selector: 'eyrus-reopen-day',
  templateUrl: './reopen-day.component.html',
  styleUrls: ['./reopen-day.component.sass']
})
export class ReopenDayComponent implements OnInit {

  public loading = false;

  @Input() contractId;
  @Input() calendarDate;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private api: ApiRequestsService,
    private projectService: ProjectsService
  ) { }


  ngOnInit() {

  }

  public completeDaily() {

    if(this.loading) return;
    this.loading = true;

    const payload = {
      calendarDate: this.calendarDate
    };

    this.api.dailyLogs.reopenDay(this.contractId, payload)
      .then(result => {
        this.activeModal.close(result);
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
      });
  }

}
